export default __webpack_public_path__ + "static/media/IMG-20211128-WA0005.b717445d.jpg";